import GlobalUiStore from './GlobalUiStore';

const globalUiStore = new GlobalUiStore();
export default globalUiStore;
